
// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

export default function DefaultContainer({ children }) {
    return (
        <Container>
            <Row>
                <Col>{children}</Col>
            </Row>
        </Container>
    );
}

DefaultContainer.propTypes = {
    children: PropTypes.node
};
DefaultContainer.defaultProps = {
    children: null
};